<template>
  <div class="t_page">
    <div class="left_body">
      <p class="left_header">个人资料</p>
      <div class="picture">
        <el-image
          :src="jbxxForm.avatar ? returnShowPic + jbxxForm.avatar : avatar"
          :draggable="false"
          style="width: 120px; height: 120px; margin: auto"
          alt=""
        />
      </div>
      <el-upload
        class="upload-demo"
        :before-upload="beforeUpload"
        :on-success="onSuccess"
        :on-error="onError"
        :action="returnSaveFile+'?isNotSyn=true'"
        :headers="token"
      >
        <span class="picSpan">修改头像</span>
      </el-upload>
      <div class="item">
        <div style="min-width: 89px">
          <i class="el-icon-user-solid" /> 登录账号:
        </div>
        <span>{{ jbxxForm.loginName }}</span>
      </div>
      <div class="item">
        <div style="min-width: 89px">
          <i class="el-icon-s-home" /> 所属部门:
        </div>
        <span
          style="
            overflow: hidden;
            text-overflow: ellipsis;
            -o-text-overflow: ellipsis;
            white-space: nowrap;
            width: 300px;
            display: block;
          "
        >{{ jbxxForm.deptName }}</span>
      </div>
      <div class="item">
        <div style="min-width: 89px"><i class="el-icon-date" /> 创建时间:</div>
        <span>{{ jbxxForm.cjsj }}</span>
      </div>
    </div>
    <div class="right_body">
      <p class="right_header">基本资料</p>
      <div class="tabs">
        <el-tabs v-model="activeName" type="card" :before-leave="handleClick">
          <el-tab-pane label="基本资料" name="first">
            <el-form
              ref="form"
              :rules="jbxxRule"
              :model="jbxxForm"
              label-width="180px"
            >
              <el-form-item label="用户名称：" prop="userName">
                <el-input v-model="jbxxForm.userName" />
              </el-form-item>
              <el-form-item label="联系座机：" prop="telnumber">
                <el-input v-model="jbxxForm.telnumber" />
              </el-form-item>
              <el-form-item label="邮箱：" prop="email">
                <el-input v-model="jbxxForm.email" />
              </el-form-item>
              <el-form-item label="性别：">
                <el-radio-group v-model="jbxxForm.sex">
                  <el-radio label="0">男</el-radio>
                  <el-radio label="1">女</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item>
                <el-button
                  v-preventReClick
                  icon="el-icon-check"
                  class="t_bcbtn"
                  type="primary"
                  @click="updateInfo"
                >保存</el-button>
                <el-button
                  icon="el-icon-close"
                  @click="returnBefore"
                >关闭</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="修改密码" name="second">
            <el-form
              ref="pwdform"
              :model="pwdform"
              :rules="pwRule"
              label-width="180px"
            >
              <el-form-item label="旧密码：" prop="old">
                <el-input v-model="pwdform.old" :type="flag1 ? 'text' : 'password'" >
                  <i
                    slot="suffix"
                    v-preventReClick
                    :class="flag1 ? 'el-icon-minus' : 'el-icon-view'"
                    style="margin-top: 12px; font-size: 18px;"
                    autocomplete="auto"
                    @click="flag1 = !flag1"
                  />
                </el-input>
              </el-form-item>
              <el-form-item label="新密码：" prop="new">
                <el-input v-model="pwdform.new" :type="flag2 ? 'text' : 'password'" >
                  <i
                    slot="suffix"
                    v-preventReClick
                    :class="flag2 ? 'el-icon-minus' : 'el-icon-view'"
                    style="margin-top: 12px; font-size: 18px"
                    autocomplete="auto"
                    @click="flag2 = !flag2"
                  />
                </el-input>
              </el-form-item>
              <el-form-item label="确认密码：" prop="sure">
                <el-input v-model="pwdform.sure" :type="flag3 ? 'text' : 'password'" >
                  <i
                    slot="suffix"
                    v-preventReClick
                    :class="flag3 ? 'el-icon-minus' : 'el-icon-view'"
                    style="margin-top: 12px; font-size: 18px"
                    autocomplete="auto"
                    @click="flag3 = !flag3"
                  />
                </el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  v-preventReClick
                  icon="el-icon-check"
                  class="t_bcbtn"
                  type="primary"
                  @click="passwordChange"
                >保存</el-button>
                <el-button
                  icon="el-icon-close"
                  @click="returnBefore"
                >关闭</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="修改手机号" name="third">
            <el-form
              ref="phoneform"
              :model="phoneform"
              :rules="phoneRule"
              label-width="180px"
            >
              <el-form-item label="旧手机号：" :required="true">
                <el-input v-model="jbxxForm.phonenumber" disabled />
              </el-form-item>
              <el-form-item label="旧手机号验证码：" prop="oldYzm">
                <el-input
                  v-model="phoneform.oldYzm"
                  style="width: 150px"
                />
                <el-button
                  v-preventReClick
                  class="t_bcbtn"
                  style="margin-left: 20px; width: 90px"
                  type="primary"
                  @click="getcode(1)"
                >{{ codetime1 }}</el-button>
              </el-form-item>
              <el-form-item label="新手机号：" prop="newPhone">
                <el-input v-model="phoneform.newPhone" />
              </el-form-item>
              <el-form-item label="新手机号验证码：" prop="newYzm">
                <el-input
                  v-model="phoneform.newYzm"
                  style="width: 150px"
                />
                <el-button
                  v-preventReClick
                  class="t_bcbtn"
                  style="margin-left: 20px; width: 90px"
                  type="primary"
                  @click="getcode(2)"
                >{{ codetime2 }}</el-button>
              </el-form-item>
              <el-form-item label="当前密码：" prop="password">
                <el-input
                  v-model="phoneform.password"
                  type="password"
                />
              </el-form-item>
              <el-form-item>
                <el-button
                  v-preventReClick
                  icon="el-icon-check"
                  class="t_bcbtn"
                  type="primary"
                  @click="submit"
                >保存</el-button>
                <el-button
                  icon="el-icon-close"
                  @click="returnBefore"
                >关闭</el-button>
              </el-form-item>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!--验证码弹窗-->
    <el-dialog title="请完成校验" :visible.sync="txjymShow" width="260px" @close="txjymlose">
      <div>
        <img style="cursor: pointer" :src="smsImg" @click = "codeimgSms"/>
        <el-input v-model="smsCode" placeholder="请输入图形校验码"></el-input>
      </div>
      <div style="text-align: center;margin-top:20px;">
        <el-button
          size="small"
          @click="txjymlose()"
        >取 消</el-button>
        <el-button
          v-preventReClick
          size="small"
          style="
            background-color: #0f70ff;
            border-color: #0f70ff;
            margin-left: 30px;
          "
          type="primary"
          @click="senSms"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getUserSource,
  updatePassWd,
  updateAvatar,
  getOldYzm,
  getNewYzm,
  updatePhone,
  updateInfo
} from '@/assets/js/personalCenter.js'
import { returnSaveFile, returnShowPic, getToken } from '@/assets/js/common'
import { getVerifyCode } from '@/assets/js/login'
export default {
  name: 'PersonalCenter',
  components: {},
  data() {
    const pwdValidate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入新密码'))
      } else if (value) {
        const reg = new RegExp(/((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,}$))/)
        if (!reg.test(value)) {
          callback(new Error('密码必须同时包含大写、小写、数字和特殊字符(不包含\'_\')其中三项且至少8位'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const phonenumberValidator = function(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入联系电话'))
      }
      const isTel = /^(0\d{2,3}-){0,1}\d{6,8}$/.test(value)
      const isMobile = /^1[3456789]\d{9}$/.test(value)
      if (isTel || isMobile) {
        callback()
      } else {
        callback(new Error('请输入正确的联系电话'))
      }
    }
    const YzmValidator = function(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入验证码'))
      }
      const isTel = /^\d{6}$/.test(value)
      if (isTel) {
        callback()
      } else {
        callback(new Error('格式错误'))
      }
    }

    // pattern: /^[1-9]*$/, message: '请输入正整数', trigger: 'blur'
    return {
      //图形校验码
      txjymShow: false,
      flag1: false,
      flag2: false,
      flag3: false,
      // 获取token
      token: {
        Authorization: getToken()
      },
      // 默认头像
      avatar: require('@/assets/img/rstep3t.png'),
      // 获取验证码
      codetime1: '验证码',
      codetime2: '验证码',
      // 当前标签页
      activeName: 'first',
      // 基本信息表单
      jbxxForm: {
        userName: '',
        avatar: ''
      },
      // 密码表单
      pwdform: {
        old: '',
        new: '',
        sure: ''
      },
      returnShowPic: '', // 显示图片
      returnSaveFile: '', // 保存图片
      //下面4个属性 涉及发送短信验证码
      smsImg: '',
      smsUuid: '',
      smsCode: '',
      smsType: '',
      // 手机号修改表单
      phoneform: {
        oldPhone: '',
        oldYzm: '',
        newPhone: '',
        newYzm: '',
        password: ''
      },
      pwRule: {
        old: [{ required: true, message: '请输入旧密码', trigger: 'change' }],
        new: [{ required: true, validator: pwdValidate, trigger: 'change' }],
        sure: [{ required: true, message: '请再次输入密码', trigger: 'change' }]
      },
      jbxxRule: {
        userName: [
          { required: true, message: '请输入用户名称', trigger: 'change' }
        ],
        phonenumber: [
          {
            validator: phonenumberValidator,
            trigger: ['blue', 'change']
          }
        ],
        telnumber: [
          {
            validator: phonenumberValidator,
            trigger: ['blue', 'change']
          }
        ],
        email: [
          {
            type: 'email',
            message: '请输入正确的邮箱地址',
            trigger: ['blur', 'change']
          }
        ]
      },
      phoneRule: {
        oldPhone: [
          { required: true, message: '请输入旧手机号', trigger: 'blur' }
        ],
        oldYzm: [
          {
            required: true,
            validator: YzmValidator,
            trigger: 'change'
          }
        ],
        newPhone: [
          {
            required: true,
            validator: phonenumberValidator,
            trigger: ['blur', 'change']
          }
        ],
        newYzm: [
          {
            required: true,
            validator: YzmValidator,
            trigger: 'change'
          }
        ],
        password: [
          { required: true, message: '请输入当前账号密码', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.returnSaveFile = returnSaveFile()
    this.returnShowPic = returnShowPic()
    this.loadDataSource()
  },
  methods: {
    // 修改个人信息
    updateInfo() {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.$confirm('是否提交修改信息操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              updateInfo({
                userName: this.jbxxForm.userName,
                email: this.jbxxForm.email,
                telnumber: this.jbxxForm.telnumber,
                sex: this.jbxxForm.sex
              }).then((e) => {
                if (e.data.code == '000000') {
                  this.$message({
                    message: '信息修改成功',
                    type: 'success'
                  })
                }
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        }
      })
    },
    // 修改手机号
    submit() {
      // todo 校验  修改完重新登录
      this.$refs['phoneform'].validate((valid) => {
        if (valid) {
          this.$confirm('是否提交变更?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              updatePhone({
                oldPhone: this.jbxxForm.phonenumber,
                oldCode: this.phoneform.oldYzm,
                newPhone: this.phoneform.newPhone,
                newCode: this.phoneform.newYzm,
                password: this.phoneform.password
              }).then((e) => {
                this.$message({
                  message: '信息修改成功',
                  type: 'success'
                })
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              })
            })
        }
      })
    },
    returnBefore() {
      this.$router.go(-1)
    },
    // 上传失败
    onError() {
      this.$message.error('证件上传失败!')
    },
    // 上传成功回调
    onSuccess(response, file, fileList) {
      if (response.code == '000000') {
        this.jbxxForm.avatar = response.data.url
        this.$forceUpdate()
        updateAvatar({ avatarUrl: response.data.url }).then((e) => {
          if (e.code == '000000') {
            this.$message({
              message: '头像上传成功',
              type: 'success'
            })
          }
        })
      }
      // todo
    },
    // 头像上传前
    beforeUpload(file) {
      const fileType = ['image/jpeg', 'image/png', 'image/bmp', 'image/jpg']
      const isJPG = fileType.includes(file.type)

      const isLt = file.size / 1024 < 500
      if (!isJPG) {
        this.$message.error('上传图片只能是 JPG/BMP/JPEG/PNG格式!')
      }
      if (!isLt) {
        this.$message.error('上传图片大小不能超过 500kb!')
      }
      return isJPG && isLt
    },
    // 修改密码
    passwordChange() {
      this.$refs['pwdform'].validate((valid) => {
        if (valid) {
          this.$confirm('是否提交修改密码操作?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              updatePassWd({
                oldPassword: this.pwdform.old,
                newPassword: this.pwdform.new
              }).then((e) => {
                if (e.data.code == '000000') {
                  this.$message(
                    {
                      message: '修改密码成功',
                      type: 'success'
                    },
                    2000
                  )
                }
              })
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消删除'
              })
            })
        }
      })
    },
    // 数据加载
    loadDataSource() {
      getUserSource().then((e) => {
        if (e.data.code == '000000') {
          // 获取个人中心数据
          this.jbxxForm = e.data.data
        }
      })
    },
    handleClick(active, old) {
      switch (active) {
        case 'second':
          this.$refs['pwdform'].resetFields()
          break
        case 'third':
          this.$refs['phoneform'].resetFields()
          break
      }
    },
    txjymlose() {
      this.txjymShow = false
      this.smsUuid = ''
      this.smsImg = ''
      this.smsCode = ''
      this.smsType = ''
    },
    // 点击验证码
    getcode(type){
      this.smsType = type
      if (type == 1 && this.codetime1 == '验证码') {
        this.codeimgSms()
        this.txjymShow = true
      } else if(type == 2 && this.codetime2 == '验证码'){
        this.$refs.phoneform.validateField('newPhone', (valid) => {
            if (!valid) {
              this.codeimgSms()
              this.txjymShow = true
            }
        })
      }
    },
    // 获取图片验证码图片
    codeimgSms() {
      getVerifyCode().then((e) => {
        this.smsUuid = e.data.data.uuid
        this.smsImg = e.data.data.img
      }).catch(()=>{
        this.smsUuid = ''
        this.smsImg = ''
      })
    },
    //发送短信验证码
    senSms(){
      let type = this.smsType
      var that = this
      if (type == 1) {
        // 旧手机号
        if (this.codetime1 == '验证码') {
          getOldYzm({mobilePhone:this.jbxxForm.phonenumber,code:this.smsCode,uuid:this.smsUuid}).then((e) => {
            this.txjymlose()
            this.$message({
              message: '发送成功！',
              type: 'success'
            })
            var time = 60
            var t = setInterval(function() {
              if (time == 0) {
                that.codetime1 = '验证码'
                clearInterval(t)
              } else {
                time--
                that.codetime1 = time
              }
            }, 1000)
          }).catch((e)=>{
            if(e.response.data.code != '010137'){ //非校验不通过错误，关闭图形校验码弹窗
              this.txjymlose()
            }else{
              this.codeimgSms() //刷新
            }
          })
        }
      } else {
        // 新手机号
        this.$refs.phoneform.validateField('newPhone', (valid) => {
          if (!valid) {
            if (this.codetime2 == '验证码') {
              getNewYzm({mobilePhone:this.phoneform.newPhone,code:this.smsCode,uuid:this.smsUuid}).then((e) => {
                this.txjymlose()
                this.$message({
                  message: '发送成功！',
                  type: 'success'
                })
                var time = 60
                this.codetime2 = 60
                var t = setInterval(function() {
                  if (time == 0) {
                    that.codetime2 = '验证码'
                    clearInterval(t)
                  } else {
                    time--
                    that.codetime2 = time
                  }
                }, 1000)
              }).catch((e)=>{
                if(e.response.data.code != '010137'){ //非校验不通过错误，关闭图形校验码弹窗
                  this.txjymlose()
                }else{
                  this.codeimgSms() //刷新
                }
              })
            }
          }
        })
      }
    }
  }
}
</script>

<style lang='less' scoped>
/deep/.el-upload-list {
  display: none !important;
}
.t_bcbtn {
  background-color: #4170ff;
  border-color: #4170ff;
}
.t_page {
  padding: 5px;
  display: flex;
  width: 95%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;

  .left_body {
    width: 25%;
    height: 500px;
    border: 1px solid #dddddd;
    background: #fff;
    .left_header {
      line-height: 50px;
      background-color: #f0f3f4;
      padding-left: 20px;
      margin: 0px;
    }
    .picture {
      text-align: center;
      padding-top: 20px;
    }
    /deep/.upload-demo {
      width: 65px;
      margin: auto !important;
    }
    .picSpan {
      text-align: center;
      display: block;
      margin-bottom: 20px;
    }
    .item {
      border-top: 1px solid #dddddd;
      width: 90%;
      margin: auto;
      line-height: 40px;
      color: rgb(89, 89, 89);
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
  .right_body {
    width: 75%;
    height: 500px;
    margin-left: 5px;
    background: #fff;
    border: 1px solid #dddddd;
    .right_header {
      line-height: 50px;
      background-color: #f0f3f4;
      padding-left: 20px;
      margin: 0px;
    }
    .tabs {
      padding: 20px;
    }
  }
}
</style>
